import React from 'react';

const IntellectualProperty = () => {
  return (
    <section>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Intellectual Property</h2>
      <p className="text-gray-600">
        The entire content of this website, including but not limited to graphics, logos, icons, 
        images, audio clips, digital downloads, and software, is the property of ScaleNix or its 
        content suppliers and is protected by French and international copyright laws. The compilation 
        of all content on this site is the exclusive property of ScaleNix and is protected by French 
        and international copyright laws.
      </p>
    </section>
  );
};

export default IntellectualProperty;